import { Box, Grid } from "@mui/material";
import Stack from "@mui/material/Stack";
import LanguageContext from "components/LanguageContext";
import HelpAndShare from "components/LayoutFront/HelpAndShare";
import Wrapper from "components/LayoutFront/Wrapper";
import Summary from "components/templatesComponents/Summary";
import PropTypes from "prop-types";
import React, { useContext, useMemo } from "react";
import sanitizeHtml from "sanitize-html";
import t from "utils/locales/translation.json";
import { normalized } from "utils/urlUtils";

const ArticleDsfr = (props) => {
  const { page = {} } = props;
  const { contents, template, title, shortDescription } = page;
  const { headerElement, displaySummary, dynamicPart } = contents;

  const { language } = useContext(LanguageContext);

  const bo = useMemo(() => typeof title === "object", [title]);

  const stepList = useMemo(() => {
    let stepArr;
    const stepperChildren = bo ? dynamicPart.props.children : dynamicPart;
    if (stepperChildren) {
      if (!Array.isArray(stepperChildren)) {
        stepArr = [stepperChildren];
      } else {
        stepArr = stepperChildren;
      }
      const newArray = [];
      stepArr?.forEach((step) => {
        const content = step.props.children.props.children;
        let titleContent = bo ? content?.props?.data : content || "";
        if (content) {
          if (!bo || (bo && !content.length)) {
            try {
              titleContent = decodeURIComponent(titleContent);
            } catch (e) {
              // do nothing
            }
            const titleContentArray = titleContent.split("<h2>");
            if (Array.isArray(titleContentArray)) {
              titleContentArray.forEach((tca) => {
                if (tca.includes("</h2>")) {
                  const title = sanitizeHtml(tca.split("</h2>")[0].replaceAll(/<\/?([a-z])*>/g, ""));
                  const link = `${normalized(title || "")}`;
                  newArray.push({
                    title,
                    link,
                  });
                }
              });
            }
          }
        }
      });
      return newArray;
    }
    return [];
  }, [bo, dynamicPart]);

  return (
    <Wrapper>
      <Stack sx={{ px: { xs: 2, lg: 0 }, "&.fr-text-xl": { mb: 2 }, "& figure": { mt: 1 } }}>
        <h1>{title}</h1>
        {shortDescription && <p className="fr-text--xl">{shortDescription}</p>}
        <hr />
        {headerElement}
      </Stack>
      <Grid container sx={{ justifyContent: "space-between", gap: { xs: "1.5rem", lg: "2.5rem" } }}>
        {bo || displaySummary ? (
          <Grid size={{ xs: 12, lg: 3 }}>
            <Box sx={{ position: "sticky", top: 0, px: { xs: 2, lg: 0 } }}>
              <Box sx={bo ? { opacity: displaySummary?.props?.content?.value === "true" ? 1 : 0.3 } : {}}>
                <Summary title={t[language].summary.title} items={stepList} />
              </Box>
              {bo ? displaySummary : null}
            </Box>
          </Grid>
        ) : null}
        <Grid size={{ xs: 12, lg: bo || displaySummary ? 8 : 12 }}>{dynamicPart}</Grid>
      </Grid>
      <HelpAndShare alwaysDisplayShare template={template} />
    </Wrapper>
  );
};

ArticleDsfr.propTypes = {
  page: PropTypes.shape().isRequired,
};

export default ArticleDsfr;
